import React, { FC, useState } from "react";
import { FOLDER_WHITE, ARROW_UP } from "../../../assets";
import TableComponent from "../../../shared/components/table";
import { LawyerOverviewColumns } from "../../../shared/components/table/columns/lawyerOverview";
import { SortingState } from "@tanstack/react-table";
import { Registrar1AssessmentOverviewColumns } from "../../../shared/components/table/columns/registrar1AssessmentDaqshboardColumn";

const Overview: FC = () => {
  const [sorting, setSorting] = useState<SortingState>([]);

  const stats = [
    {
      title: "Number  of submitted case folders",
      value: "67",
      increase: "19.5%",
    },
    {
      title: "Number  of folders attended to",
      value: "67",
      increase: "19.5%",
    },
    {
      title: "Number of folders yet to be attended to",
      value: "67",
      increase: "19.5%",
    },
  ];

  const recentCases = [
    {
      sn: false,
      date: "30 April 2021",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      status: "Submitted",
      query_status: "——",
      payment: "——",
      appeal_number: "CV/3047/2018",
    },
    {
      sn: false,
      date: "30 April 2021",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      status: "Submitted",
      query_status: "——",
      payment: "——",
      appeal_number: "CV/3047/2018",
    },
    {
      sn: false,
      date: "30 April 2021",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      status: "Submitted",
      query_status: "——",
      payment: "——",
      appeal_number: "CV/3047/2018",
    },
  ];

  return (
    <div className="flex flex-col gap-y-8 p-6">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white p-4 rounded-xl border border-[#E9EAEB] flex items-end justify-between"
          >
            <div className="flex items-start gap-x-4">
              <div className="min-w-8 h-8  bg-[#00B074] rounded-lg flex items-center justify-center">
                <img src={FOLDER_WHITE} alt="Folder" className="w-4 h-4" />
              </div>
              <div className="flex flex-col">
                <span className="text-[#464255] text-sm font-medium">
                  {stat.title}
                </span>
                <span className="text-[#1A1A1A] text-2xl font-bold mt-1">
                  {stat.value}
                </span>
              </div>
            </div>
            <div className="flex items-center justify-center gap-x-1 bg-[#E6F7F1] px-2 py-1 rounded-full ">
              <img src={ARROW_UP} alt="Increase" className="w-3 h-3" />
              <span className="text-[#00B074] text-xs font-medium">
                {stat.increase}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Recent Cases Table */}
      <div className="bg-white p-6 rounded-xl border border-[#E9EAEB]">
        <h3 className="text-[#1A1A1A] font-bold text-lg mb-6">Recent cases</h3>
        <TableComponent
          DATA={recentCases}
          // @ts-ignore
          COLUMNS={Registrar1AssessmentOverviewColumns}
          sorting={sorting}
          setSorting={setSorting}
        />
        <div className="mt-6 flex flex-col items-center gap-y-4">
          <div className="h-[2px] w-[200px] bg-gray-100 rounded-full"></div>
          <div className="flex items-center gap-x-2 text-[#464255] text-sm">
            <span>10 more case</span>
            <button className="px-4 py-2 border border-[#E9EAEB] rounded-lg text-[#1A1A1A] font-medium hover:bg-gray-50 transition-colors">
              See more
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
